const TYPING_TAGS = new Set(['input', 'textarea', 'select'])

/**
 * Skip Catch Board shortcuts while the user is typing in a field.
 * @param {EventTarget|null|undefined} target
 */
export function isCatchBoardShortcutTypingTarget(target) {
  if (!target || typeof target !== 'object') {
    return false
  }

  const element = /** @type {HTMLElement} */ (target)
  const tag = String(element.tagName || '').toLowerCase()
  if (TYPING_TAGS.has(tag)) {
    return true
  }
  if (element.isContentEditable) {
    return true
  }
  return Boolean(element.closest?.('input, textarea, select, [contenteditable="true"]'))
}

export function focusCatchBoardSearch() {
  const root = document.querySelector('[data-testid="catch-board-search"]')
  const input =
    root?.querySelector?.('input') ||
    (root && String(root.tagName || '').toLowerCase() === 'input' ? root : null)
  if (input && typeof input.focus === 'function') {
    input.focus()
    if (typeof input.select === 'function') {
      input.select()
    }
  }
}

/**
 * @param {KeyboardEvent} event
 * @returns {'new-deal'|'search'|null}
 */
export function getCatchBoardShortcut(event) {
  if (!event || event.metaKey || event.ctrlKey || event.altKey) {
    return null
  }
  if (isCatchBoardShortcutTypingTarget(event.target)) {
    return null
  }
  if (event.key === 'n' || event.key === 'N') {
    return 'new-deal'
  }
  if (event.key === '/') {
    return 'search'
  }
  return null
}
